var MembershipQuestionAnswers = /** @class */ (function () {
    function MembershipQuestionAnswers() {
    }
    MembershipQuestionAnswers.fromQuestions = function (questions) {
        var _qa = questions.reduce(function (qa, question) {
            qa[question.questionId] = { question: question };
            return qa;
        }, {});
        var mqa = new MembershipQuestionAnswers();
        mqa.qa = _qa;
        return mqa;
    };
    MembershipQuestionAnswers.prototype.getQuestionIdAnswers = function () {
        return this.getAllAnswers()
            .filter(function (a) { return a.textAnswer; })
            .map(function (a) {
            return { questionId: a.question.questionId, textAnswer: a.textAnswer };
        });
    };
    MembershipQuestionAnswers.prototype.getAllAnswers = function () {
        return Object.values(this.qa);
    };
    MembershipQuestionAnswers.prototype.getAnswer = function (questionId) {
        return this.qa[questionId];
    };
    MembershipQuestionAnswers.prototype.answer = function (questionId, textAnswer) {
        var qa = this.qa[questionId];
        qa.textAnswer = textAnswer;
        return qa;
    };
    MembershipQuestionAnswers.prototype.isValid = function (questionId) {
        var qa = this.getAnswer(questionId);
        return !qa.question.required || (qa.question.required && !!qa.textAnswer);
    };
    return MembershipQuestionAnswers;
}());
export { MembershipQuestionAnswers };
//# sourceMappingURL=MembershipQuestionAnswers.js.map